import { useRef } from "preact/compat";
import { useEffect, useState } from "preact/hooks";
import PropTypes from "prop-types";

export default function YesNoInput({
  label,
  name,
  currentValue,
  onChange,
  hidden,
  mode = "toggle",
  disabled = false,
  labelTextClassName = "",
  children,
}) {
  /**
   *
   * @type {RefObject<HTMLInputElement|null>}
   */
  const rawInputRef = useRef(null);
  const [value, setValue] = useState(currentValue);

  const changeToggle = (e) => {
    const inputElement = e.target;
    const newState = inputElement.checked ? "yes" : "no";

    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value",
    ).set;

    nativeInputValueSetter.call(rawInputRef.current, newState);

    const event = new Event("input", { bubbles: true });
    rawInputRef.current.dispatchEvent(event);

    setValue(newState);
  };

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  return (
    <fieldset className={`${hidden ? "fieldset hidden" : "fieldset flex items-center"}`}>
      <input
        onChange={changeToggle}
        type="checkbox"
        className={
          mode === "toggle"
            ? "toggle toggle-secondary shadow-none"
            : "checkbox checkbox-secondary shadow-none!"
        }
        disabled={disabled}
        checked={value === "yes"}
      />
      <input onChange={onChange} ref={rawInputRef} type="text" className="hidden" name={name} />
      <div className="flex flex-col pl-1">
        <legend className={`${labelTextClassName} fieldset-legend mb-0`}>{label}</legend>
        {children}
      </div>
    </fieldset>
  );
}

YesNoInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  currentValue: PropTypes.string,
  onChange: PropTypes.func,
  hidden: PropTypes.bool,
  mode: PropTypes.oneOf(["checkbox", "toggle"]),
  disabled: PropTypes.bool,
  labelTextClassName: PropTypes.string,
  children: PropTypes.node,
};
